var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ScrollLocker',{attrs:{"locked":_vm.scrollLocked}},[(!_vm.loading)?_c(_vm.appLayout,{tag:"Component"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }